'use client';
import React from 'react';
import { useRouter } from '@/intl/navigation';
import { Service } from './Service';
import httpCodes from '@/constants/httpCodes';
import { ErrorType } from '@/ui/features/authentication/components/errorAlert';
import appRoutes from '@/constants/routes';

export function useController() {
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] =
    React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [apiError, setApiError] = React.useState(ErrorType.NONE);
  const router = useRouter();

  const handleSignup = async (payload: {
    username: string;
    email: string;
    password: string;
    refferedBy?: string;
  }) => {
    setLoading(true);
    try {
      const response = await Service.register(payload);
      setLoading(false);

      if (response.status === httpCodes.SUCCESS) {
        router.push(appRoutes.login);
      } else {
        handleApiError(response.status);
      }
    } catch (error) {
      setApiError(ErrorType.UNEXPECTED);
      setLoading(false);
    }
  };

  const handleApiError = (status: number) => {
    switch (status) {
      case httpCodes.CONFLICT:
        setApiError(ErrorType.CONFLICT);
        break;
      default:
        setApiError(ErrorType.UNEXPECTED);
    }
  };

  return {
    passwordVisible,
    confirmPasswordVisible,
    setPasswordVisible,
    setConfirmPasswordVisible,
    loading,
    apiError,
    handleSignup,
  };
}
